import React from "react";
import TerminalWindow from "../../../components/TerminalWindow";

const TvWindow = ({
  isMinimized,
  onMinimize,
  onMaximize,
  onClose,
  children,
  title = "debug-console-contact",
  className = "",
}) => {
  return (
    <TerminalWindow
      isMinimized={isMinimized}
      onMinimize={onMinimize}
      onMaximize={onMaximize}
      onClose={onClose}
      title={title}
      className={className}
    >
      {children}
    </TerminalWindow>
  );
};

export default TvWindow;
